import { PageOrientation, defaults, getAPIMethod } from 'typed/api';
import { ExtractAction, NetworkAction, entityActionSet, networkAction } from './utils';
import { download } from 'typed/utils';

export const
    { loadAll: loadAllPartnerSupportLevels } = entityActionSet(defaults.PartnerSupportLevel, {
        loadAll: networkAction('LOAD_ALL_PARTNER_SUPPORT_LEVELS', getAPIMethod('PartnerSupportLevel', 'loadAll'))
    }),

    { loadAll: loadAllPartnerClientCompanyTypes } = entityActionSet(defaults.PartnerClientCompanyType, {
        loadAll: networkAction('LOAD_ALL_PARTNER_CLIENT_COMPANY_TYPES', getAPIMethod('PartnerClientCompanyType', 'loadAll'))
    }),

    { loadAll: loadAllPartnerClientCompanyEventTypes } = entityActionSet(defaults.PartnerClientCompanyEventType, {
        loadAll: networkAction('LOAD_ALL_PARTNER_CLIENT_COMPANY_EVENT_TYPES', getAPIMethod('PartnerClientCompanyEventType', 'loadAll'))
    }),

    partnerClientCompanies = entityActionSet(defaults.PartnerClientCompanyReport, {
        loadAll: networkAction('LOAD_ALL_PARTNER_CLIENT_COMPANIES', getAPIMethod('PartnerClientCompany', 'loadAll')),
        edit: networkAction('EDIT_PARTNER_CLIENT_COMPANY', getAPIMethod('PartnerClientCompany', 'edit'))
    }),

    downloadOrganizationChartPdf = (imageDataUrl: string, fileName: string, pageOrientation: PageOrientation = PageOrientation.PORTRAIT):
        NetworkAction<'DOWNLOAD_ORGANIZATION_CHART_PDF', { imageDataUrl: string; fileName: string; pageOrientation: PageOrientation; }, void> =>
        async (dispatch: any) => {
            const response = await dispatch(networkAction(
                'DOWNLOAD_ORGANIZATION_CHART_PDF',
                { imageDataUrls: [imageDataUrl] },
                getAPIMethod('CompanyFunctionApi', 'companyFunctionGenerateOrganizationChartPdfPut'),
                [imageDataUrl],
                { pageOrientation }
            ));

            if (response) {
                const linkSource = `data:application/pdf;base64,${response}`;
                download(linkSource, fileName);
            }
        };

export type CompanyAction = ExtractAction<
    | typeof loadAllPartnerSupportLevels
    | typeof loadAllPartnerClientCompanyTypes
    | typeof loadAllPartnerClientCompanyEventTypes
    | typeof partnerClientCompanies
    | typeof downloadOrganizationChartPdf
>;